<template>
  <div :class="[$style.root, 'pa-3']">
    <v-alert
      v-if="!isOrderCompleted"
      :class="$style.alert"
      dense
      border="left"
      type="warning"
    >
      Debes seleccionar:
      <!-- <br /> -->
      <template v-for="(composition, index) in compositions">
        <span :key="composition.id">
          <template v-if="index > 0">, </template>
          <span>1 {{ composition.name.replace('_', ' ') }}</span>
        </span>
      </template>
    </v-alert>

    <v-row align="end" justify="between">
      <v-col class="pb-2">
        <div class="mb-2">
          <b>Subtotal: </b>
          <span>{{ order && order.total | formatCurrency }}</span>
        </div>

        <v-btn color="#4c4250" dark size="sm" @click="onCartReview">
          Revisar pedido
        </v-btn>
      </v-col>

      <v-col class="pt-2 pb-4" cols="auto">
        <v-btn
          color="#dac8f9"
          :disabled="!isOrderCompleted"
          size="sm"
          @click="onAddToCartWoo"
        >
          Agregar e ir a Pagar
        </v-btn>
      </v-col>

      <!-- <b-button variant="info" size="sm" @click="onAddToCartWoo">
      Agregar y seguir comprando
    </b-button> -->
    </v-row>

    <MinicartModal
      ref="minicartModal"
      :order="order"
      @updateOrder="$emit('updateOrder')"
    />
  </div>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator'

import Order from '@/models/order.model'

import MinicartModal from 'Components/composite-product/CompositeProductMinicartModal'

@Component({
  components: {
    MinicartModal,
  },
})
export default class CompositeProductMinicart extends Vue {
  @Prop({
    type: Array,
    default: () => [],
  })
  compositions

  created() {
    console.log('Minicart', this.order)
  }

  onCartReview() {
    this.$refs.minicartModal.show()
  }

  onAddToCartWoo() {
    const formCart = document.querySelector('button[name="add-to-cart"]')

    formCart.click()
  }

  get order() {
    return Order.query().first()
  }

  get isOrderCompleted() {
    return this.order && this.order.isCompleted
  }
}
</script>

<style lang="scss" module>
.root {
  background-color: rgba($highlight3, 0.725);
  box-shadow: 0 1px 5px 0 rgba(16, 24, 40, 0.1),
    0 1px 3px 0 rgba(16, 24, 40, 0.1);
  // display: flex;
  position: -webkit-sticky;
  position: sticky;
  text-shadow: 1px 1px 1px #e4cca6, -1px -1px 1px #e4cca6, 1px -1px 1px #e4cca6,
    -1px 1px 1px #e4cca6;
  bottom: 0;
  top: 0;
  z-index: 5;

  .alert {
    // color: #f1585e;
    text-shadow: none;
  }
}
</style>
